module.exports = __webpack_public_path__ + "static/media/sharp_logo.3c4efd2b.png";